import React, { useEffect, useState } from "react";
import { Button, Form, Select, Space, Input } from "antd";
import { useSnackbar } from "notistack";
import { useAxios } from "../../contexts/AxiosProvider";
import { InstrumentApi } from "../../services/InstrumentApi";
import { ClientApi } from "../../services/ClientApi";
import { EngagementApi } from "../../services/EngagementApi";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 8,
  },
};

const AddEngagement = ({ userData, setIsAddEngagementModalOpen }) => {
  const axios = useAxios();
  const { enqueueSnackbar } = useSnackbar();
  const [clientData, setClientData] = useState({
    clientList: [],
    totalDomains: 0,
  });
  const [assetTag, setAssetTag] = useState("");
  const [instruments, setInstruments] = useState({
    instrumentList: [],
  });
  const [loading, setloading] = useState(false);

  const [form] = Form.useForm();

  const fetchAllClients = async () => {
    try {
      setloading(true);
      const data = {
        user_id: userData.userId,
        domain: false,
        domain_id: "",
        search: false,
        searchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClientData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(true);
    }
  };

  const fetchAllInstruments = async (client_id) => {
    try {
      setloading(true);
      const response = await InstrumentApi.getInstrumentsByClientId(
        axios,
        client_id
      );
      if (response.status === 200) {
        setInstruments({ ...instruments, instrumentList: response.data });
      }
    } catch (error) {
      enqueueSnackbar("Internal Server Error!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    fetchAllClients();
  }, []);

  const onClientChange = (value) => {
    form.setFieldsValue({
      client: value,
      instrument: "",
    });
    // fetchAllInstruments(false, "", value);
    fetchAllInstruments(value);
  };
  const onEngagementChange = (value) => {
    form.setFieldsValue({
      instrument: value,
    });
  };

  const onFinish = async (values) => {
   const selectedInstrument = instruments.instrumentList.find(
    (instrument) => instrument.instrumentId === values.instrument
  );
    const data = {
      engagementName: selectedInstrument?.instrumentName || "",
      clientId: values.client,
      assetTag: values.asset_tag,
      userId: userData.userId,
      userName: userData.username,
    };
    try {
      const response = await EngagementApi.createEngagement(axios, data);
      if (response.status === 201) {
        enqueueSnackbar("Pipeline added successfully!", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        form.resetFields();
        setIsAddEngagementModalOpen(false);
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 403) {
        enqueueSnackbar("You have only Read Permission !!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else if (error.response?.status === 409) {
        enqueueSnackbar("Pipeline with the same name already exists!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else if (error.response.status === 500) {
        enqueueSnackbar("Internal Server Error!!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };
  const onReset = () => {
    form.resetFields();
    setInstruments({ instrumentList: [] });

  };

  console.log(form);
  return (
    <Form
      {...layout}
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      style={{
        maxWidth: 600,
      }}
    >
      <Form.Item
        name="client"
        label="Select Sub-Function"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select style={{ width: 200 }} onChange={onClientChange}>
          {clientData.clientList?.map((item) => {
            if (item.status === "approved") {
              return (
                <Option key={item.client_id} value={item.client_id}>
                  {item.client_name}
                </Option>
              );
            }
          })}
        </Select>
      </Form.Item>

      <Form.Item
        name="instrument"
        label="Select Data Source"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select style={{ width: 200 }} onChange={onEngagementChange}>
          {instruments.instrumentList?.map((item) => {
            return (
              <Option key={item.instrumentId} value={item.instrumentId}>
                {item.instrumentName}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item
        name="asset_tag"
        label="Asset Tag"
        rules={[
          {
            required: true,
            message: "Please enter asset tag",
          },
        ]}
      >
        <Input
          size="large"
          id="asset_tag"
          name="asset_tag"
          autoComplete="off"
          value={assetTag}
          onChange={(e) => {
            setAssetTag(e.target.value);
            form.setFieldsValue({ asset_tag: e.target.value });
          }}
        />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default AddEngagement;
